export const isAcademyCoordinator = user => user?.role === 'academy_coordinator';
export const loginDestination = user => isAcademyCoordinator(user) ? '/coordinator' : '/';
export function clearWorkspaceSession() {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('selectedCompanyId');
  sessionStorage.clear();
}
